import Login from '@viewsG/login'
import Register from '@viewsG/register'
import Home from '@viewsG/home'
import PackageDetail from '@viewsG/packageDetail'
import Me from '@viewsG/me'
import MyDevice from '@viewsG/myDevice'
import MyDataPlan from '@viewsG/myDataPlan'
import MyOrder from '@viewsG/myOrder'
import AccountInfo from '@viewsG/accountInfo'
import FAQ from '@viewsG/FAQ'
import ContactUs from '@viewsG/contactUs'
import BillAddress from '@viewsG/billAddress'
import BindSim from '@viewsG/bindSim'
import PayResult from '@viewsG/payResult'
import EmptyCard from '@viewsG/emptyCard'
import EnTermsOfUse from '@src/containers/viewsG/termsAndPrivacy/terms/en_terms'
import DeTermsOfUse from '@src/containers/viewsG/termsAndPrivacy/terms/de_terms'
import EnPrivacy from '@src/containers/viewsG/termsAndPrivacy/privacy/en_privacy'
import DePrivacy from '@src/containers/viewsG/termsAndPrivacy/privacy/de_privacy'
import ActiveDetail from '@src/containers/viewsG/activePackage'
import Suggest from '@viewsG/suggest'
import Submission from '@viewsG/suggest/submission'
const basePath = 'global/'
export const globalAppRouter = [
    {path: basePath + 'login', component: Login},
    {path: basePath + 'empty-card', component: EmptyCard},
    {path: basePath + 'sign-up', component: Register},
    {path: basePath + 'home', component: Home},
    {path: basePath + 'packageDetail/:countryCode/:countryName/:goodsReleaseId/:type/:cargoType/:activityId?', component: PackageDetail},
    {path: basePath + 'billAddress/:countryCode/:countryName/:goodsType/:goodsReleaseId/:cargoType/:activityId?', component: BillAddress},
    {path: basePath + 'me', component: Me},
    {path: basePath + 'myDevice', component: MyDevice},
    {path: basePath + 'myDataPlan', component: MyDataPlan},
    {path: basePath + 'myOrder', component: MyOrder},
    {path: basePath + 'accountInfo', component: AccountInfo},
    {path: basePath + 'FAQ', component: FAQ},
    {path: basePath + 'contactUs', component: ContactUs},
    {path: basePath + 'bind-simCard', component: BindSim},
    {path: basePath + 'result-cybersource/:orderId/:reasonCode', component: PayResult},
    {path: basePath + 'result-aci', component: PayResult},
    {path: basePath + 'en-terms', component: EnTermsOfUse},
    {path: basePath + 'de-terms', component: DeTermsOfUse},
    {path: basePath + 'en-privacy', component: EnPrivacy},
    {path: basePath + 'de-privacy', component: DePrivacy},
    {path: basePath + 'active-detail', component: ActiveDetail},
    {path: basePath + 'suggest', component: Suggest},
    {path: basePath + 'submission', component: Submission},
]
